var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FF860D",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.284 8h-7.55a1.6 1.6 0 0 0-1.368.768L8.74 16.372a.8.8 0 0 0 .683 1.216h3.655a.32.32 0 0 1 .295.442l-3.302 7.953c-.128.31.246.583.502.367l13.355-11.27c.57-.482.23-1.412-.516-1.412h-3.92a.32.32 0 0 1-.232-.541l3.602-3.775A.8.8 0 0 0 22.285 8"
  })));
};
export default SvgIcon;